import Login from './Login'
import LoginEmp from './LoginEmp'
import Home from './Home'
import LoginFailed from './LoginFailed'
import LoginEmpCheckinfo from './LoginEmpCheckinfo'
import LoginPage from './LoginPage'
export default {
  Login,
  Home,
  LoginFailed,
  LoginEmp,
  LoginEmpCheckinfo,
  LoginPage
}



// WEBPACK FOOTER //
// ./src/components/Core/index.js